import { render, staticRenderFns } from "./BetterKolmar_sx.vue?vue&type=template&id=b3e3d218"
import script from "./BetterKolmar_sx.ts?vue&type=script&lang=ts&external"
export * from "./BetterKolmar_sx.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports